var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74264 1.22226C9.35214 0.831766 8.71927 0.83142 8.32843 1.22226L1.25736 8.29333C0.866515 8.68417 0.866861 9.31705 1.25736 9.70754L8.32843 16.7786C8.58211 17.0323 8.9386 17.1209 9.26496 17.0439C9.44001 17.0036 9.60591 16.9153 9.74264 16.7786C10.1335 16.3878 10.1331 15.7549 9.74264 15.3644L3.37868 9.00044L9.74264 2.63648C10.1335 2.24563 10.1331 1.61276 9.74264 1.22226Z",
    fill: "#586A84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPrev);
export default __webpack_public_path__ + "static/media/arrowPrev.3505c2368d16c1020b57ece503aed90c.svg";
export { ForwardRef as ReactComponent };